import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UITag from 'UIComponents/tag/UITag';
import { getDraftBriefByContact } from './utils/api/QualifiedLeadsApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RetailTag = props => /*#__PURE__*/_jsx(UITag, Object.assign({}, props, {
  use: "sorbet",
  children: "Self Service Motion"
}));
const TargetAccountTag = props => /*#__PURE__*/_jsx(UITag, Object.assign({}, props, {
  use: "info",
  children: "Target account"
}));
function QualifiedLeadFlags(props) {
  const [brief, setBrief] = useState(null);
  const fetchBrief = contactVid => {
    getDraftBriefByContact(contactVid).then(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JSON' is not assignable to param... Remove this comment to see the full error message
    result => setBrief(result), __ => setBrief(null)).catch(console.log);
  };
  useEffect(() => fetchBrief(props.contactVid), [props.contactVid]);
  useEffect(() => {
    const handleWindowEvents = event => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data
      } = event;
      if (!data.payload || `${data.payload.leadContactVid}` !== `${props.contactVid}`) {
        return;
      }
      switch (data.type) {
        case 'QL_PANEL_META_LOADED':
          fetchBrief(props.contactVid);
          break;
        default:
          break;
      }
    };
    window.addEventListener('message', handleWindowEvents, false);
    return () => {
      window.removeEventListener('message', handleWindowEvents);
    };
  }, [props.contactVid]);
  if (!brief) {
    return null;
  }
  if (brief.isTargetAccount && brief.isRetail) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(TargetAccountTag, {}), /*#__PURE__*/_jsx(RetailTag, {
        className: "m-left-2"
      })]
    });
  } else if (brief.isTargetAccount) {
    return /*#__PURE__*/_jsx(TargetAccountTag, {
      className: "m-left-2"
    });
  } else if (brief.isRetail) {
    return /*#__PURE__*/_jsx(RetailTag, {
      className: "m-left-2"
    });
  } else {
    return null;
  }
}
QualifiedLeadFlags.propTypes = {
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default QualifiedLeadFlags;